import { RouteRecordRaw } from "vue-router";
import PdfViewPage from "@/modules/Document/PdfViewPage.vue";

const documentRoutes: Array<RouteRecordRaw> = [
    {
        path: "/pdf",
        children: [
            {
                path: "view/:id?",
                component: PdfViewPage,
                props: true,
            },
        ],
    },

];

export default documentRoutes;
